
// src/web/components/diary-user.jsx

import React from 'react'
import { themr } from 'react-css-themr'
import diaryTheme from './themes/diary.css'
import {
  Button,
} from 'react-toolbox/lib/button'

@themr('Diary', diaryTheme)
class DiaryUser extends React.Component {
  showUser = ()=> this.props.showUser(this.props.user.user_id)

  render() {
    const {
      user,
      theme,
      showUser,
    } = this.props

    return <Button neutral={false} ripple={false} theme={theme} className="user"
            label={user.name} onClick={this.showUser} />
  }
}

export default DiaryUser



// WEBPACK FOOTER //
// ./src/web/components/diary-user.jsx